import axios from 'axios';
import { Sidebar } from './Sidebar';
import React, { useContext, useMemo, useRef } from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { Header } from './Header';

import { Footer } from './Footer';
import Banner from './components/Banner';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import LoginReg from './LoginReg';
import { AuthContext } from '../context/Authcontext';
import '../assets/AdminCss/games.css';
import MarqueeBottom from './components/MarqueeBottom';
import { useTheme } from '../context/ThemeContext';

const base_url=process.env.REACT_APP_API_URL;

const CasinoGames = () => {
    const { themeColors } = useTheme();
    const [isSidebar, setSidebar] = useState(false);
    const [games, setGames]= useState([]);
    const [token, setToken]= useState();
    const [live, setLive]= useState([]);                       
    const [multiPlayer, setMultiPlayer]= useState([]);
    const [roulette, setRoulette]= useState([]);
    const [baccarat, setBaccarat]= useState([]);
    const [indian, setIndian]= useState([]);
    const [patti, setPatti]= useState([]);
    const [crash, setCrash]= useState([]);
    const [blackjack, setBlackJack]= useState([]);
    const [poker, setPoker]= useState([]);
    const [slots, setSlots]= useState([]);
    const [scratch, setScratch]= useState([]);
    const [shooting, setShooting]= useState([]);
    const [sicbo, setSicbo]= useState([]);
    const [lightning, setLightning]= useState([]);
    const [sexyCasino, setSexyCasino]= useState([]);
    const [tablegames, setTablegames]= useState([]);
    const [esports, setEsports]= useState([]);
    const location= useLocation();

    const [list, setList]= useState(location?.state?.list || 0);
    const [searchText, setSearchText] = useState('');

    const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);


  const scrollTabs = (dir) => {
    const el = document.getElementById("casinoTabs");
    if (!el) return;

    el.scrollBy({
      left: dir === "left" ? -200 : 200,
      behavior: "smooth",
    });
  };

  const tabStyle = (index) => ({
    padding: "6px 12px",
    alignItems: "center",
    cursor: "pointer",
    flexShrink: 0,
    fontWeight: 600,
    background: list === index ? "#000" : "transparent",
    color: "#fff",
    borderRadius: "2px",
    width:'auto'
  });


    const casinoGames = async () => {
      try {


        const eventSource = new EventSource(base_url + '/api/valid/token', {
          withCredentials: true
        });
        
        let receivedGames = [];
        

        const allowedProviders = [
          'Evolution', 'Ezugi', 'Betgames', 'Royal Gaming', 'Skywind Live', 
          'JiLi Gamin', 'Royal Gami', 'SA Gaming', 'BETER Live'
        ];
    
        const slotProviders = [
          "Red Tiger", "Habanero", "Hacksaw Gaming", "Nolimit City", "OneTouch", 
          "Triple PG", "Relax Gaming", "Evoplay", "Quickspin", "Nolimit Ci", 
          "Dragoon So", "GameArt", "Mobilots", "NetEnt", "AVATAR UX", "Boongo", 
          "Iron Dog Studio", "Play'n Go", "CQ9 Casino", "Print Studios", 
          "Push Gaming", "1x2 Gaming", "Thunderkick", "Hacksaw Ga", "Jili Gaming"
        ];
    
        // Handle token message
        eventSource.addEventListener('message', (event) => {
          const data = JSON.parse(event.data);
          
          // Set token when received
          if (data.token) {
            setToken(data.token);
          }
          
          // Process game chunks as they arrive
          if (data.chunk && Array.isArray(data.chunk)) {
            // Add new games to our collection
            receivedGames = [...receivedGames, ...data.chunk];

            setGames(receivedGames);

            updateGameCategories(receivedGames, allowedProviders, slotProviders);

          }
          
          // Handle completion
          if (data.complete) {
            eventSource.close();
          }
          
          // Handle errors
          if (data.error) {
            // console.error("Error fetching games:", data.error);
            eventSource.close();
          }
        });
        
        // Handle connection errors
        eventSource.onerror = (error) => {
          // console.error("EventSource error:", error);

          eventSource.close();
        };
        
      } catch (err) {
        console.error("Error in casinogames function:", err);
      }
    };
    
    // Helper function to categorize games
    const updateGameCategories = (games, allowedProviders, slotProviders) => {
      const casino = games?.filter(gme => allowedProviders.includes(gme?.provider?.name));
      const multi = games?.filter(gme => gme?.provider?.name.includes('Jili'));
      const roulet = games?.filter(gme => gme?.name.includes('Roulette'));
      const bacart = games?.filter(gme => gme?.name.includes('Baccarat'));
      const Indian = games?.filter(gme => 
        gme?.name.includes('Teenpatti') || 
        gme?.name.includes('Poker') || 
        gme?.name.includes('Rummy') || 
        gme?.name.includes('Joker') || 
        gme?.name.includes('Casino')
      );
      const teenpatti = games?.filter(gme => 
        gme?.name.includes('Teenpatti') || 
        gme?.name.includes('Teen Patti') || 
        gme?.provider?.name === 'Jili Gamin' || 
        gme?.provider?.name === 'Royal Gaming'
      );
      const crashh = games?.filter(gme => 
        gme?.name.includes('Aviator') || 
        gme?.name.includes('JetX') || 
        gme?.name.includes('Crash') 
      );
      const black = games?.filter(gme => gme?.name.includes('Blackjack'));
      const pokerr = games?.filter(gme => 
        gme?.name.includes('Poker') || 
        gme?.name.includes('Bets') || 
        gme?.name.includes('Texas')
      );
      const slot = games?.filter(gme => slotProviders.includes(gme?.provider?.name));
      const srcratchGames = games?.filter(gme => gme?.provider?.name === 'PlayPearls');
      const shooting = games?.filter(gme => gme?.provider?.name === 'Dragoon Soft');
      const sic = games?.filter(gme => gme?.name.includes('Sic Bo'));
      const light = games?.filter(gme => gme?.name.includes('Lightning'));
      const sexy = games?.filter(gme => gme?.name.includes('Sexy'));
      const table = games?.filter(gme => 
        gme?.name.includes('Poker') || 
        gme?.name.includes('Teenpatti') || 
        gme?.name.includes('Teen Patti') || 
        gme?.name.includes('Studio') || 
        gme?.name.includes('Blackjack') || 
        gme?.name.includes('BlackJack') || 
        gme?.name.includes('Roulette') || 
        gme?.name.includes('Card') || 
        gme?.name.includes('Baccarat')
      );
    
      // Update all game category states
      setLive(casino);
      setMultiPlayer(multi);
      setRoulette(roulet);
      setBaccarat(bacart);
      setIndian(Indian);
      setPatti(teenpatti);
      setCrash(crashh);
      setBlackJack(black);
      setPoker(pokerr);
      setSlots(slot);
      setScratch(srcratchGames);
      setShooting(shooting);
      setSicbo(sic);
      setLightning(light);
      setSexyCasino(sexy);
      setTablegames(table);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const handleResize = () => {
          if (window.innerWidth > 991) {
            setSidebar(true);
          } else {
            setSidebar(false);
          }
        };
        handleResize();
      }, []);


    useEffect(()=>{
      window.scrollTo(0,0);
  
      casinoGames();

    },[]);



      const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
    useEffect(() => {
        const handleResize = () => {
          setIsLargeScreen(window.innerWidth > 991);
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);


    
    return (
        <app-root _nghost-jrx-c101="" ng-version="12.2.16" >
          
          <div _ngcontent-jrx-c101="">
            <app-toasts
              _ngcontent-jrx-c101=""
              aria-live="polite"
              aria-atomic="true"
              className="ngb-toasts"
            ></app-toasts>
            <router-outlet _ngcontent-jrx-c101=""></router-outlet>
            <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
              <div _ngcontent-jrx-c95="" className="head-container gamess">
                <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />
                <div _ngcontent-jrx-c95="" className="body-container mb-5">
                  <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
                  <div
                    _ngcontent-jrx-c95=""
                    className={`rightbar`}
                    style={{
                      width: isSidebar ? "" : "2500%",
                      transition: "width 0.3s ease-in-out",
                      backgroundColor: themeColors['--dark-theme-data-bg'],
                    }}
                  >
{/*     
                    <div className="news-bar">  
                    </div>
                    <Banner /> */}
                    
    
                    <app-upcoming
                      _ngcontent-jrx-c95=""
                      _nghost-jrx-c94=""
                      className="ng-star-inserted"
                    >

                      {/* <div className='d-flex gap-1'>
                        <input type='text' className='border-0 rounded w-100 ' placeholder='Game Name' onChange={(e) => setSearchText(e.target.value)} style={{background:themeColors['--dark-theme-card-bg-light']}}/>
                        <button className='cancel-button' onClick={() => setSearchText('')}>Cancel</button>
                      </div> */}

                   <div
      style={{
        background: "#0088cca5",
        // padding: "5px",
        // paddingBottom: "0px",
        display: "flex",
        alignItems: "center",
        marginBottom: "5px",
        height: "35px",
      }}
    >
      {/* LEFT ARROW */}
      <button
        onClick={() => scrollTabs("left")}
        style={{
          border: "none",
          backgroundImage:"linear-gradient(to right, #0088cc82,#cccccc)",
          fontSize: "22px",
          fontWeight: "bold",
          cursor: "pointer",
          padding: "0px 20px",
          color: "#000",
          // marginRight: "6px",
        }}
      >
        ‹
      </button>

      {/* TABS */}
      <ul
        id="casinoTabs"
        className="popular-tab ng-star-inserted d-flex gap-3"
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          paddingBottom: "0px",
          marginBottom: "0px",
          whiteSpace: "nowrap",
          listStyle: "none",
          flex: 1,
          scrollbarWidth: "none", // Firefox
        }}
      >
        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 0 ? "activee" : ""}`}
          onClick={() => setList(0)}
          style={tabStyle(0)}
        >
          All Casino
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 4 ? "activee" : ""}`}
          onClick={() => setList(4)}
          style={tabStyle(4)}
        >
          Teen Patti
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 5 ? "activee" : ""}`}
          onClick={() => setList(5)}
          style={tabStyle(5)}
        >
          Indian Casinos
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 6 ? "activee" : ""}`}
          onClick={() => setList(6)}
          style={tabStyle(6)}
        >
          Multiplayer
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 7 ? "activee" : ""}`}
          onClick={() => setList(7)}
          style={tabStyle(7)}
        >
          Live Casinos
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 9 ? "activee" : ""}`}
          onClick={() => setList(9)}
          style={tabStyle(9)}
        >
          Roulette
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 10 ? "activee" : ""}`}
          onClick={() => setList(10)}
          style={tabStyle(10)}
        >
          Baccarat
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 11 ? "activee" : ""}`}
          onClick={() => setList(11)}
          style={tabStyle(11)}
        >
          Crash Games
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 12 ? "activee" : ""}`}
          onClick={() => setList(12)}
          style={tabStyle(12)}
        >
          Sic Bo
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 13 ? "activee" : ""}`}
          onClick={() => setList(13)}
          style={tabStyle(13)}
        >
          Lightning
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 14 ? "activee" : ""}`}
          onClick={() => setList(14)}
          style={tabStyle(14)}
        >
          Poker
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 15 ? "activee" : ""}`}
          onClick={() => setList(15)}
          style={tabStyle(15)}
        >
          Blackjack
        </li>

        <li
          tabIndex="0"
          className={`d-flex text-nowrap lis ${list === 16 ? "activee" : ""}`}
          onClick={() => setList(16)}
          style={tabStyle(16)}
        >
          Slot Games
        </li>
      </ul>

      {/* RIGHT ARROW */}
      <button
        onClick={() => scrollTabs("right")}
        style={{
          border: "none",
           backgroundImage:"linear-gradient(to right, #0088cc82,#cccccc)",
          fontSize: "22px",
          fontWeight:"bold",
          cursor: "pointer",
          padding: "0px 20px",
          marginLeft: "6px",
              color: "#000",
        }}
      >
        ›
      </button>
    </div>

                      
                    </app-upcoming>
                    {list===0 && <AllCasino games={games} searchText={searchText} token={token} />}
                    {list===4 && <TeenPatti teenpatti={patti} token={token} />}
                    {list===5 && <IndianCasino indian={indian} token={token} />}
                    {list===6 && <MultiPlayer multiPlayer={multiPlayer} token={token} />}
                    {list===7 && <LiveCasino live={live} token={token}/>}
                    {list===9 && <Roulette roulette={roulette} token={token}/>}
                    {list===10 && <Baccarat baccarat={baccarat} token={token}/>}
                    {list===11 && <CrashGames crash={crash} token={token}/>}
                    {list===12 && <SicBo sicbo={sicbo} token={token}/>}
                    {list===13 && <Lightning lightning={lightning} token={token}/>}
                    {list===14 && <Poker poker={poker} token={token}/>}
                    {list===15 && <BlackJack blackjack={blackjack} token={token}/>}
                    {list===16 && <Slots slots={slots} token={token}/>}
                    {list===17 && <SexyCasino sexyCasino={sexyCasino} token={token}/>}
                    {list===18 && <TableGames tablegames={tablegames} token={token}/>}
                    {list===19 && <Shooting shooting={shooting} token={token}/>}
                    {list===20 && <Esport esports={esports} token={token}/>}
                    {/* {list===21 && <Scratch scratch={scratch} token={token}/>} */}
                    {list===22 && <Providers />}
                    
    
                    {/* <Footer /> */}
                  </div>
                </div>
                <MarqueeBottom onMenuClick={handleCanvasShow} />
              </div>
            </app-landing-page-new>
           
    
            <div className="slider-container"></div>
          </div>
        </app-root>
      );
}

export default CasinoGames;


const AllCasino = ({ games, searchText, token }) => {
  const [active, setActive] = useState(false);
  const [filteredGames, setFilteredGames] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const searchTimeoutRef = useRef(null);
  const { isAuthenticated } = useContext(AuthContext);


  useEffect(() => {
    setFilteredGames(games || []);
  }, [games]);


  useEffect(() => {

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!searchText) {
      setFilteredGames(games || []);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);

    searchTimeoutRef.current = setTimeout(() => {
      const lowerCaseSearch = searchText.toLowerCase();

      const filtered = games.filter(game => {

        if (!game) return false;
        if (game.name?.toLowerCase().includes(lowerCaseSearch)) return true;
        if (game.provider?.name?.toLowerCase().includes(lowerCaseSearch)) return true;
        return false;
      });
      
      setFilteredGames(filtered);
      setIsSearching(false);
    }, 300);
    

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [games, searchText]);

  const openGameById = async(gameId) => {
    try {
      const response = await axios.post(base_url + '/api/gamelaunch/url',
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          }
        }
      );

      if(response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;
      } else {
        toast.error('Please Login to play!');
        setActive(true);
      }
    } catch(err) {
      console.log(err);
      toast.error('Unable to launch game. Please try again.');
    }
  };

  const gameCards = useMemo(() => {
    return filteredGames?.map((game, index) => (
      <div
        key={game?.id || index}
        className=" mb-2 game-card-wrapper"
        onClick={() => {if(isAuthenticated) openGameById(game?.id)}}
      >
        <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
          <div className="pop-carousel">
            <img
              className="slider-sport rounded-top img-fluid w-100"
              src={game?.images?.[2]?.url}
              alt={game?.category || 'Casino Game'}
              // style={{height:'100%'}}
              loading='lazy'
            />
          </div>
         
          {!isAuthenticated && (
            <div className="login-overlay d-flex justify-content-center align-items-center">
              <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                e.stopPropagation();
                setActive(true);
              }}>
                LOGIN
              </button>
            </div>
          )}
          {isAuthenticated && (
            <div className="play-overlay d-flex justify-content-center align-items-center">
              <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                e.stopPropagation();
                openGameById(game?.id);
              }}>
                PLAY NOW
              </button>
            </div>
          )}
        </div>
      </div>
    ));
  }, [filteredGames, isAuthenticated]);

  return(
    <>
      <div className="upcoming-container">
        {isSearching && (
          <div className="text-center my-2">
            <span className="text-white">Searching...</span>
          </div>
        )}
        
        {!isSearching && filteredGames.length === 0 && searchText && (
          <div className="text-center my-4">
            <p className="text-white">No games found matching "{searchText}"</p>
          </div>
        )}
        
        <div className="d-flex flex-wrap justify-content-around px-1">
          {gameCards}
        </div>
      </div>
    </>
  );
};

const TeenPatti= ({teenpatti, token}) =>{


  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);

  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {teenpatti?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm " style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid "
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
          
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
};



const IndianCasino= ({indian, token}) => {

  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);

  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {indian?.map((game, index) => (
          <div
            key={index}
            className="mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm " style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid "
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
            
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
};


const MultiPlayer= ({multiPlayer, token})=>{
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);

  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {multiPlayer?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
          
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const LiveCasino= ({live, token})=>{
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {live?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
            
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

const Roulette= ({roulette, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {roulette?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
             
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const Baccarat= ({baccarat, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap jxustify-content-around px-1">
        {baccarat?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
           
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const CrashGames= ({crash, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {crash?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
          
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

const SicBo= ({sicbo, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {sicbo?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
             
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const Lightning= ({lightning, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {lightning?.map((game, index) => (
          <div
            key={index}
            className="mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
         
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const Poker= ({poker, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {poker?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
            
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

const BlackJack= ({blackjack, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {blackjack?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
          
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const Slots= ({slots, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {slots?.map((game, index) => (
          <div
            key={index}
            className="mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
            
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const SexyCasino= ({sexyCasino, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {sexyCasino?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
          
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const TableGames= ({tablegames, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {tablegames?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
           
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const Shooting= ({shooting, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {shooting?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
            
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}


const Esport= ({shooting, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {shooting?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
          
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

const Scratch= ({scratch, token})=> {
  const [active, setActive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please LOGIN.');
          setActive(true);
        }


    }catch(err){
        console.log(err);
    }
  }


  return(
    <>
     {/* {<LoginReg active={active} setactive={setActive} />} */}
    <div className="upcoming-container">
      <div className="d-flex flex-wrap justify-content-around px-1">
        {scratch?.map((game, index) => (
          <div
            key={index}
            className=" mb-2 game-card-wrapper"
            onClick={() =>{if(isAuthenticated) openGameById(game?.id)}}
          >
            <div className="rounded shadow-sm w-100" style={{ cursor: 'pointer' }}>
              <div className="pop-carousel">
                <img
                  className="slider-sport rounded-top img-fluid w-100"
                  src={game?.images[2]?.url}
                  alt={game?.category}
                  style={{height:'14rem'}}
                  loading='lazy'
                />
              </div>
              <div
                className="w-100 d-flex flex-column gap-2 pb-3 px-2 rounded-bottom"
                style={{ background: '#393939' }}
              >
                <span style={{ color: '#959292', fontSize: '12px' }}>
                  SCRATCH
                </span>

                 {/* <h3 className="text-white m-0 fnsz">{game?.name}</h3> */}

                <span style={{ color: '#959292', fontSize: '12px' }}>
                  {game?.provider?.name}
                </span>
              </div>
              {!isAuthenticated && (
                <div className="login-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={(e) => {
                    e.stopPropagation();
                    setActive(true);
                  }}>
                    LOGIN
                  </button>
                </div>
              )}
              {isAuthenticated && (
                <div className="play-overlay d-flex justify-content-center align-items-center">
                  <button className="btn text-white fw-bold btnnn" onClick={() =>openGameById(game?.id)}>
                    PLAY NOW
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

const Providers= () => {

  const provider=[
    {
      src:'/assets/providers/SPB.png',
      name:'SPRIBE',
      total:'1',
    },
    {
      src:'/assets/providers/Evolotion.png',
      name:'EVOLUTION',
      total:'1',
    },
    {
      src:'/assets/providers/Ezugi.png',
      name:'EZUGI',
      total:'1',
    },
    {
      src:'/assets/providers/qt.png',
      name:'QTECH',
      total:'1',
    },
    {
      src:'/assets/providers/play.png',
      name:"PLAY'N GO",
      total:'1',
    },
    {
      src:'/assets/providers/RED.png',
      name:'RED TIGER',
      total:'1',
    },
    {
      src:'/assets/providers/EVP.png',
      name:'EVOPLAY',
      total:'1',
    },
    {
      src:'/assets/providers/NET.png',
      name:'NETENT',
      total:'1',
    },
    {
      src:'/assets/providers/CQC.png',
      name:'CQ9 CASINO',
      total:'1',
    },
    {
      src:'/assets/providers/Blueprint.png',
      name:'BLUEPRINT GAMING',
      total:'1',
    },
    {
      src:'/assets/providers/YGG.png',
      name:'YGGDRASIL',
      total:'1',
    },
    {
      src:'/assets/providers/HAB.png',
      name:'HABANERO',
      total:'1',
    },
    {
      src:'/assets/providers/HAK.png',
      name:'HACKSAW GAMING',
      total:'1',
    },
    {
      src:'/assets/providers/Playp.png',
      name:'PLAYPEARLS',
      total:'1',
    },
    {
      src:'/assets/providers/GameArt.png',
      name:'GAMEART',
      total:'1',
    },
    {
      src:'/assets/providers/Quickspin.png',
      name:'QUICKSPIN',
      total:'1',
    },
    {
      src:'/assets/providers/JiLi.png',
      name:'JILI GMAMING',
      total:'1',
    },
    {
      src:'/assets/providers/RTG.png',
      name:'RED TIGER',
      total:'1',
    },
    {
      src:'/assets/providers/1x2.png',
      name:'1X2 GAMING',
      total:'1',
    },
    {
      src:'/assets/providers/RLX.png',
      name:'RELAX GAMING',
      total:'1',
    },
    {
      src:'/assets/providers/NLC.png',
      name:'NOLIMIT CITY',
      total:'1',
    },
    {
      src:'/assets/providers/Onetouch.png',
      name:'ONETOUCH',
      total:'1',
    },
    {
      src:'/assets/providers/Dragoon.png',
      name:'DRAGOON SOFT',
      total:'1',
    },
    {
      src:'/assets/providers/TK.png',
      name:'THUNDERKICK',
      total:'1',
    },
    {
      src:'/assets/providers/IDS.png',
      name:'IRON DOG STUDIO',
      total:'1',
    },
    {
      src:'/assets/providers/TPG.png',
      name:'TRIPLE PG',
      total:'1',
    },
    {
      src:'/assets/providers/GZX.png',
      name:'GAMZIX',
      total:'1',
    },
    {
      src:'/assets/providers/NGE.png',
      name:'NETGAME ENTERTAINMENT',
      total:'1',
    },
    {
      src:'/assets/providers/WOO.png',
      name:'WOOHOO GAMES',
      total:'1',
    },
    {
      src:'/assets/providers/_AUX.png',
      name:'AVATAR UX',
      total:'1',
    },
    {
      src:'/assets/providers/FNG.png',
      name:'FANTASMA GAMES',
      total:'1',
    },
    {
      src:'/assets/providers/RG.png',
      name:'REVOLVER GAMING',
      total:'1',
    },
    {
      src:'/assets/providers/FUG.png',
      name:'FUGASO',
      total:'1',
    },
    {
      src:'/assets/providers/SWL.png',
      name:'SKYWIND LI',
      total:'1',
    }
  ]

  return(
    <div className="main-container px-5">
      <div className="row">
        {provider?.map((provide, index) => (
          <div key={index} className="col-md-4 col-lg-3">
            <div
              className="d-flex flex-column rounded p-3"
              style={{ background: '#393939' }}
            >
              <div className="text-center py-5">
                <img src={provide?.src} height={80} alt="img" className='custom' />
              </div>
              <span className="text-white px-2 fw-bold">{provide?.name}</span>
              <span className="text-white px-2">Total Games: {provide?.total}</span>
            </div>
          </div>
        ))}
      </div>
    </div>


  )
}